import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

const StyledContainer = styled('div', {
  alignSelf: 'flex-end', // align to the right
  paddingTop: '$core.spacing.100',
  paddingHorizontal: '$core.spacing.50',
  borderColor: '$core.color.neutral.20',
  borderWidth: '$core.border-width.sm',
  borderRadius: '$core.border-radius.md',
  width: '80%',
});

const CardHeader = styled(Text, {
  fontWeight: '$core.font-weight.xbold',
  color: '$core.color.brand.100',
  marginBottom: '$core.spacing.100',
  paddingTop: '$core.spacing.100',
  paddingHorizontal: '$core.spacing.200',
});

const ItemWrapper = styled('div', {
  //   marginBottom: '$core.spacing.250'
});

const ItemContainer = styled('div', {
  flexDirection: 'row',
  marginBottom: '$core.spacing.150',
  alignItems: 'flex-start',
  marginLeft: '$core.spacing.200',
});

const Item = styled(Text, {
  flex: 2,
  color: '$core.color.neutral.70',
  fontWeight: '$core.font-weight.semibold',
});
const Details = styled(Text, {
  flex: 3,
  color: '$core.color.brand.140',
  fontWeight: '$core.font-weight.semibold',
});
const DateText = styled(Text, {
  color: '$core.color.brand.140',
  fontWeight: '$core.font-weight.semibold',
});
const Time = styled(Text, {
  color: '$core.color.brand.140',
  fontWeight: '$core.font-weight.semibold',
});
const TimeBox = styled('div', {
  flex: 3,
  flexDirection: 'column',
});

export interface ReviewAppointmentProps {
  reason: string;
  provider: string;
  visit: string;
  when: { date: string; time: string };
}
interface ItemCardProps {
  itemName: string;
  description: string;
}

interface ItemCardTimeProps {
  itemName: string;
  description: { date: string; time: string };
}

const ReviewAppointment: React.FC<ReviewAppointmentProps> = ({ reason, provider, visit, when }) => {
  return (
    <StyledContainer>
      <CardHeader>Review appointment</CardHeader>
      <ItemWrapper>
        <ItemCard itemName="Reason" description={reason} />
        <ItemCard itemName="Provider" description={provider} />
        <ItemCard itemName="Visit" description={visit} />
        <ItemCardTime itemName="When" description={when} />
      </ItemWrapper>
    </StyledContainer>
  );
};

const ItemCard: React.FC<ItemCardProps> = ({ itemName, description }) => {
  return (
    <ItemContainer>
      <Item>{itemName}</Item>
      <Details>{description}</Details>
    </ItemContainer>
  );
};

const formatDate = (dateStr: string): string => {
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

const formatTime = (timeStr: string): string => {
  if (timeStr.toUpperCase().includes('AM') || timeStr.toUpperCase().includes('PM')) {
    return timeStr;
  }
  const parts = timeStr.split(':');
  const hoursNum = parseInt(parts[0], 10);
  const minutes = parts[1];
  const ampm = hoursNum >= 12 ? 'PM' : 'AM';
  const hours12 = hoursNum % 12 || 12;
  return `${hours12}:${minutes} ${ampm}`;
};

const ItemCardTime: React.FC<ItemCardTimeProps> = ({ itemName, description }) => {
  return (
    <ItemContainer style={{ marginBottom: 20 }}>
      <Item>{itemName}</Item>
      <TimeBox>
        <DateText>{description?.date ? formatDate(description.date) : ''}</DateText>
        <Time>{description?.time ? formatTime(description.time) : ''}</Time>
      </TimeBox>
    </ItemContainer>
  );
};

export default ReviewAppointment;
